export function hasValue(value): boolean {
  return value !== null && value !== undefined;
}